import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IAdsCheckoutStore } from '../modules/ads-checkout';
import { ICustomerStore } from '../modules/customers';

export enum UiStatus {
  Idle = 'Idle',
  Busy = 'Busy',
  Error = 'Error'
}

/**
 * redux store
 */
export interface IStore {
  adsCheckout: IAdsCheckoutStore;
  customer: ICustomerStore;
}

export type Thunk<Return, A extends Action> = ThunkAction<Return, IStore, void, A>;

/**
 * Mock Data -- this should be obtained from backend
 */
export const MockCustomers = [
  { name: 'Apple', id: '1' },
  { name: 'Ford', id: '2' },
  { name: 'Nike', id: '3' },
  { name: 'Unilever', id: '4' }
];

export const MockAdsTypeId = {
  Classic: 'Classic',
  Premium: 'Premium',
  Standout: 'Standout'
};



// WEBPACK FOOTER //
// ./src/common/type.ts